<template>
  <div class="text-right">
    <template v-if="!thePnl">
      <span class="opacity-50">0 USDT</span>
      <div v-if="!theIsClose" :class="[
        'font-semibold opacity-50'
      ]">0%</div>
    </template>
    <template v-else>
      <div :class="[
        thePnl > 0 ? $theme.successPnlColor : '',
        thePnl < 0 ? $theme.dangerPnlColor : '',
        'font-semibold'
      ]">
        <template v-if="thePnl > 0">
          +{{ roundAmount(thePnl, 6) }}
        </template>
        <template v-else>
          {{ roundAmount(thePnl, 6) }}
        </template> USDT
      </div>
      <div v-if="!theIsClose" :class="[
        thePercent > 0 ? $theme.successPnlColor : '',
        thePercent < 0 ? $theme.dangerPnlColor : '',
        'font-semibold'
      ]">{{ thePercent ? roundAmount(thePercent, 2) : 0.00 }}%</div>
    </template>
  </div>
</template>
<script>
import {roundAmount} from "@/helpers/numberHelper"

export default {
  props: [
      'pnl',
      'percent',
      'is_close'
  ],
  computed: {
    thePnl() {
      return parseFloat(this.pnl);
    },
    thePercent() {
      return parseFloat(this.percent);
    },
    theIsClose() {
      return this.is_close;
    },
  },
  data() {
    return {
      roundAmount
    }
  },
  mounted() {
  }
}
</script>
